import React from 'react'
import {
    StyledTelethonCountdown,
    StyledTelethonTrianglesRight,
    StyledTelethonTrianglesLeft,
    StyledTelethonLogo,
    StyledTelethonKids,
    RedText,
    DonateNow,
    heartIconClassname,
    LogoAndInfoContent,
    DonateContent,
    Content,
    StyledDonateMessage,
    BoldStyled,
    StyledHeart,
} from './TelethonCountdown.styled'

import { Product } from 'component-library/__product'
import { Countdown } from './Countdown'
import { useLocationState } from 'common/data/location-detection/location-detection'
import { useProduct } from "common/hooks/useProduct"

const trianglesLeft = require('./assets/triangles-left.svg')
const trianglesRight = require('./assets/triangles-right.svg')
const telethonLogo = require('./assets/telethon-logo-horizontal.svg')
const telethonKids = require('./assets/telethon-kids-2019@2x.png')

const targetDate = new Date('Sat Oct 26 2019 18:30:00 GMT+0800')

export function TelethonCountdown() {
    const { userSelectedRegion } = useLocationState()
    const product = useProduct()
    const [hideCountdown, setHideCountdown] = React.useState(
        targetDate.getTime() < new Date().getTime()
    )

    const countdownComplete = () => {
        setHideCountdown(true)
    }

    const getDonationLink = () => {
        const utmLink = (masthead: string) =>
            `https://www.telethon7.com/donate/?utm_source=${masthead}&utm_medium=Referral&utm_campaign=telethon2019&utm_term=donate&utm_content=countdownwidget`

        switch (product) {
            case Product.PerthNow:
                return utmLink('PerthNow')
            case Product.SevenNews:
                return utmLink('7NEWS')
            default:
                // Default to the west
                return utmLink('TheWest')
        }
    }

    // If 7NEWS and location !== WA dont show anything
    if (product === Product.SevenNews && userSelectedRegion !== 'WA') {
        return null
    }

    return (
        <StyledTelethonCountdown>
            <StyledTelethonKids>
                <img src={telethonKids} />
            </StyledTelethonKids>
            <StyledTelethonTrianglesLeft src={trianglesLeft} />
            <Content offset={hideCountdown}>
                <LogoAndInfoContent hiddenCountdown={hideCountdown}>
                    <StyledTelethonLogo src={telethonLogo} />
                    <p>
                        On <RedText>October 26 & 27</RedText> we’ll be{' '}
                        <RedText>painting the town red.</RedText> Join us as we celebrate giving in
                        WA.
                    </p>
                </LogoAndInfoContent>
                <DonateContent>
                    <DonateNow href={getDonationLink()}>
                        <StyledHeart className={heartIconClassname} />
                        {'Donate Now'}
                    </DonateNow>
                    <Countdown
                        hideWhenComplete={true}
                        targetDate={targetDate}
                        countdownFinished={() => countdownComplete()}
                    />
                </DonateContent>
            </Content>
            <StyledTelethonTrianglesRight offsetForContent={hideCountdown} src={trianglesRight} />
            <StyledDonateMessage showContent={hideCountdown}>
                <span>
                    {'Give generously '}
                    <BoldStyled>{'this Telethon Weekend'}</BoldStyled>
                </span>
            </StyledDonateMessage>
        </StyledTelethonCountdown>
    )
}
